import api from '../config/api';

const funcionesCargoContratoService = {
  async obtenerPorEmpresa(empresaId) {
    try {
      const response = await api.get(`/configuracion-contratos/empresa/${empresaId}/funciones-cargo`);
      return {
        success: true,
        data: response.data.data || [],
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Error al obtener funciones del cargo',
        data: [],
      };
    }
  },

  async guardar(empresaId, cargo, funciones) {
    try {
      const response = await api.post('/configuracion-contratos/funciones-cargo', {
        empresa_id: empresaId,
        cargo,
        funciones,
      });
      return {
        success: true,
        data: response.data.data,
        message: response.data.message || 'Funciones del cargo guardadas exitosamente',
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Error al guardar funciones del cargo',
        errors: error.response?.data?.errors,
      };
    }
  },

  async eliminar(id) {
    try {
      const response = await api.delete(`/configuracion-contratos/funciones-cargo/${id}`);
      return {
        success: true,
        message: response.data.message || 'Funciones del cargo eliminadas exitosamente',
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Error al eliminar funciones del cargo',
      };
    }
  },
};

export default funcionesCargoContratoService;
